export type Flavor = 'uc' | 'sc';

export function mapToFlavor(value: string): Flavor {
  return value === 'sc' ? 'sc' : 'uc';
}

export function getFlavorName(flavor: Flavor): string {
  return flavor === 'uc' ? 'UploadCam' : 'SchoolCam';
}

export function getFlavorDomain(flavor: Flavor): string {
  return flavor === 'uc' ? 'uploadcamapp.com' : 'schoolcamapp.com';
}
